<template>
  <eventi-edit-component :jsonData="jsonData" :utente="utente" :pathResource="pathResource" :titoloEvento="titoloEvento" @update="onUpdateJsonData">
    <template slot="tab-content-event">
      <spirometria-edit-component :jsonData="jsonData" @update="onUpdateJsonData"></spirometria-edit-component>
    </template>
  </eventi-edit-component>
</template>
<script>
import EventiEditComponent from "../../../base/components/EventiEditComponent.vue";
import EventiMixin from "../../../utility/mixins/EventiMixins";
import UtilityMixin from "../../../../../utility/UtilityMixin";
import SpirometriaEditComponent from "../components/SpirometriaEditComponent.vue";
export default {
  props: {
    utente: {
      type: Object,
      default: function () {
        return null;
      },
    },
  },
  mixins: [UtilityMixin],
  components: { EventiEditComponent, SpirometriaEditComponent },
  computed: {
    idPaziente() {
      return this.$route.query.idPaziente;
    },
    linkPatient() {
      return EventiMixin.getLinkPatient(this.utente, this.idPaziente);
    },
  },
  mounted() {
    this.jsonData.dataEvento = new Date().getTime();
  },
  data() {
    return {
      linkback: null,
      titoloEvento: "Spirometria",
      pathResource: "/pazienteeventispirometrie",
      pathRestValidation: "/validation",
      id: "-1",
      isFirmato: false,
      childKey: 0,
      tabIndex: 0,
      showModalLoading: false,
      jsonData: {
        dataEvento: new Date().getTime(),
        fvc: null,
        fev1: null,
        fev1Fvc: null,
        pef: null,
        fef2575: null,
        mef25: null,
        mef50: null,
        mef75: null,
        mvv: null,
        conclusioni: "",
        firma: "",
        /*Valori Nomali */

        fvcNormale: null,
        fev1Normale: null,
        fev1FvcNormale: null,
        pefNormale: null,
        fef2575Normale: null,
        mef25Normale: null,
        mef50Normale: null,
        mef75Normale: null,
        mvvNormale: null,
      },
    };
  },
  methods: {
    onFirmaUpdate() {
      let me = this;
      me.loadData();
    },
    onUpdateFile() {
      let me = this;
      me.childKey++;
    },
    onUpdateJsonData(data) {
      let me = this;
      me.jsonData = data;
    },
  },
};
</script>
